<template>
  <el-card class="box-card c-accreditation__card">
    <div class="c-accreditation__header">
      <h4 class="c-text--medium c-text--transform-upper">
        Аккредитация {{ prefixes.titleList }} у компании:
      </h4>
    </div>
    <ul class="c-accreditation__list">
      <li
        v-for="field in approveFields"
        :key="field.inn"
        class="c-accreditation__item"
      >
        <el-card class="box-card c-accreditation__card">
          <div class="c-accreditation__wrapper">
            <div class="c-accreditation__wrapper-title">
              <h3
                class="
                  c-accreditation__title
                  c-text--medium c-text--transform-upper c-text--align-center
                "
              >
                {{ field.name }}
              </h3>
            </div>
            {{ field.statusId }}
            <template v-if="![0, 4].includes(+field.description.statusId)">
              <div class="c-accreditation__wrapper-title">
                <h3
                  class="
                    c-accreditation__title
                    c-text--medium c-text--transform-upper
                  "
                  :class="field.description.cssClass"
                >
                  {{ field.description.title }}
                </h3>
              </div>

              <template v-if="checkField(field)">
                <div class="c-accreditation__wrapper-btn">
                  <el-button
                    v-for="button in field.buttons"
                    :key="button.title"
                    class="c-accreditation__btn c-accreditation__btn--full"
                    :type="button.type"
                    :title="button.title"
                    @click="changeApproveStatus(button.nextStatusId, field.inn)"
                  >
                    {{ button.title }}
                  </el-button>
                </div>
              </template>
              <div v-else class="c-accreditation__wrapper-btn" />
            </template>
            <template v-else>
              <template v-if="checkField(field)">
                <div
                  v-for="button in field.buttons"
                  :key="button.title"
                  class="c-accreditation__wrapper-title"
                >
                  <el-button
                    class="c-accreditation__btn c-accreditation__btn--full"
                    :type="button.type"
                    :title="button.title"
                    @click="changeApproveStatus(button.nextStatusId, field.inn)"
                  >
                    {{ button.title }}
                  </el-button>
                </div>
              </template>
            </template>
          </div>
        </el-card>
      </li>
    </ul>
  </el-card>
</template>
<script>
import { approveStatuses } from './statusDescription'
import { mapGetters } from 'vuex'

export default {
  inject: ['permitToSeeActions', 'createListOfButtons', 'initStatusId'],
  props: {
    entity: {
      type: Object,
      required: true,
    },
    prefixes: {
      type: Object,
      default: () => ({}),
    },
    linkByRel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      approveFields: {},
    }
  },
  computed: {
    ...mapGetters({ user: 'userProfile/userInfo' }),
    checkField() {
      return field =>
        'buttons' in field &&
        this.permitToSeeActions &&
        field.buttons.length > 0
    },
  },
  watch: {
    entity: {
      deep: true,
      handler() {
        this.init()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    statusByInn(inn) {
      return (
        (Object.prototype.hasOwnProperty.call(this.entity, 'approve_status') &&
          this.entity.approve_status[inn]) ||
        this.initStatusId
      )
    },
    init() {
      if (
        !Object.prototype.hasOwnProperty.call(this.user, 'can_approve_from')
      ) {
        return
      }
      this.approveFields = Object.assign(
        {},
        this.user.can_approve_from.map(item => {
          let temp = { ...item }

          temp.status = this.statusByInn(Number(temp.inn))
          temp.description = approveStatuses.find(
            i => Number(i.statusId) === Number(temp.status),
          )
          temp.buttons = this.createListOfButtons(temp.status)

          return temp
        }),
      )
    },
    changeApproveStatus(nextStatusId, inn) {
      const params = {
        link_by_id: this.entity.id,
        link_by_rel: this.linkByRel,
        status: nextStatusId,
        user_org_inn: Number(inn),
      }

      this.$emit('update', params, {
        fieldToUpdate: 'approve_status',
        inn: params.user_org_inn,
      })
    },
  },
}
</script>

<style lang="scss" scope>
.el-card__body {
  padding: 10px;
}
</style>
